import { apiFetchInit, apiUrl } from '@/modules/core/apiUrl';

let signOutHandler = null;

/** Register a sign-out callback (set from AuthProvider consumers if needed). */
export function setAuthFetchSignOutHandler(handler) {
  signOutHandler = handler;
}

function authorizationHeaderValue(options = {}) {
  const headers = options.headers || {};
  if (typeof Headers !== 'undefined' && headers instanceof Headers) {
    return headers.get('Authorization') || headers.get('authorization');
  }
  return headers.Authorization || headers.authorization || null;
}

function isUsableBearerToken(authHeader) {
  if (!authHeader || typeof authHeader !== 'string') return false;
  if (!authHeader.startsWith('Bearer ')) return false;
  const token = authHeader.slice('Bearer '.length).trim();
  return Boolean(token) && token !== 'undefined' && token !== 'null';
}

/**
 * Fetch wrapper that handles 401s.
 * Pass Authorization in options.headers — callers supply the Stytch session JWT.
 * Missing/malformed tokens do not revoke the session (avoids login race logout).
 */
export async function authFetch(url, options = {}, onAuthError = null) {
  try {
    const response = await fetch(apiUrl(url), apiFetchInit(options));

    if (response.status === 401) {
      const authHeader = authorizationHeaderValue(options);
      if (!isUsableBearerToken(authHeader)) {
        console.log('Authentication failed (401) with missing/malformed token — not signing out');
        return response;
      }

      console.log('Authentication failed (401), signing out user');
      if (onAuthError) onAuthError();
      try {
        if (signOutHandler) await signOutHandler();
      } catch (signOutError) {
        console.error('Error signing out user:', signOutError);
      }
    }

    return response;
  } catch (error) {
    console.error('Error in authFetch:', error);
    throw error;
  }
}

export function useAuthFetch() {
  return authFetch;
}
